export const setFeatures = (state, response) => {
    state.features = response;
};

export const setFeaturesByTenant = (state, response) => {
    state.featuresByTenant = response;
};

export const setTimelineEnabledFeature = (state, response) => {
    state.timelineEnabled = response && response.data && response.data.enabled;
};
